import { useTranslation } from 'react-i18next'

const Classmate1Start = (props) => {

  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="classmate1-start-title"
      fill="none"
      {...props}
    >
      <title id="classmate1-start-title">{t('antagonists:classmate1:components:start')}</title>
      <defs>
        <clipPath id="classmate1-b">
          <path
            d="M1614.18 900.8c-12.45.82-14.15 11.42-17.88 14.65-3.72 3.23-4.47 8.69-4.47 8.69s4.72 10.43 4.72 18.37 6.7 23.34 6.7 23.34 15.39-1.24 27.81-1.74c12.42-.5 22.6-2.48 22.6-2.48s4.22-4.97-.74-14.15c-4.97-9.19-8.19-8.19-13.16-18.37-4.97-10.18-6.7-16.64-6.7-16.64s-3.72-12.66-18.87-11.67Z"
            style={{
              fill: '#feca1b',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-c">
          <path
            d="M1538.59 520.54c-13.46-.79-34.44.4-41.17 14.25-6.73 13.86-6.33 22.56-6.33 22.56s-15.04 4.35-17.42 16.63c-2.38 12.27.4 11.88 3.56 27.71 3.17 15.83 14.69 41.11 24.59 58.13 9.9 17.02 11.92 39.44 11.92 39.44s49.9-4.17 72.46-44.95c22.56-40.77 10.97-47.48 15.72-61.74 4.75-14.25 1.19-30.09-4.75-36.02-5.94-5.94-9.5-5.94-9.5-5.94s-1.98-15.83-12.27-17.42c-10.29-1.58-36.81-12.67-36.81-12.67Z"
            style={{
              fill: '#eb6a36',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-d">
          <path
            d="M1553.77 478.83s-8.37 20.77-15.44 28.08c-7.06 7.32-19.07 13.55-19.07 13.55l12.06-20.44s-10.24 2.33-15.78 9.55c-6.22 8.11-6.92 20.47-1.62 29.55 5.3 9.08 10.6 19.68 22.2 19.43s15.63-4.43 22.95-9.73c7.32-5.3 8.84-7.42 10.35-14.49 1.51-7.06 1.04-14.67 1.04-14.67l-12.55 14.57s3.48-18.74.81-29.96c-1.24-5.21-4.94-25.45-4.94-25.45Z"
            style={{
              fill: '#dfbe84',
            }}
          />
        </clipPath>
        <clipPath id="classmate1-e">
          <path
            d="M1495.45 899.23c12.46-.69 15.43 9.63 19.51 12.39 4.09 2.76 5.48 8.09 5.48 8.09s-3.43 10.92-2.47 18.81c.96 7.89-3.84 23.98-3.84 23.98s-15.43.62-27.82 1.62c-12.38 1-22.73.26-22.73.26s-4.79-4.42-.96-14.14c3.82-9.72 7.15-9.12 10.85-19.83 3.7-10.7 4.65-17.32 4.65-17.32s2.17-13.02 17.33-13.86Z"
            style={{
              fill: '#feca1b',
            }}
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#f8f7f0}.h{fill:#f08d64}.i{fill:#eb6a36}.j{fill:#f1f1f3}.k{fill:#feca1b}.l{fill:#6b5738}.m{fill:#8cabbc}.n{fill:#dfbe84}.o{fill:#dda141}.p{fill:#afb1b4}.q{fill:#e2a972}.r{fill:#a93985}.s{fill:#235a96}.t{fill:#1a4431}.u{fill:#497125}.v{fill:#4f4e47}.w{clip-path:url(#classmate1-c)}.x{clip-path:url(#classmate1-b)}.y{clip-path:url(#classmate1-e)}'
          }
        </style>
      </defs>
      <path
        transform="rotate(179.63 1680.565 771.97)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1674.69 769.86h11.77v4.15h-11.77z"
      />
      <path
        transform="rotate(179.63 1685.646 853.812)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1679.78 851.7h11.77v4.15h-11.77z"
      />
      <path
        transform="rotate(176.05 1687.45 941.96)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1681.54 939.94h11.77v4.15h-11.77z"
      />
      <path
        transform="rotate(-1.13 1410.711 768.44)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1404.62 766.11h11.77v4.15h-11.77z"
      />
      <path
        transform="rotate(-1.13 1407.371 850.046)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1401.68 848.06h11.77v4.15h-11.77z"
      />
      <path
        transform="rotate(2.46 1405.651 936.692)"
        style={{
          fill: '#8cabbc',
        }}
        d="M1402.22 936.31h11.77v4.15h-11.77z"
      />
      <path
        d="M1404.44 737.94c-4.29-.12-4.8 2.12-4.94 7.77-.14 5.65-1.92 211.7-2.2 215.09-.28 3.39-.34 7.84 4.18 7.84s4.73-5.19 4.58-8.44c-.14-3.25 2.34-211.1 2.34-213.93 0-2.83 1.13-8.19-3.96-8.34Z"
        style={{
          fill: '#f8f7f0',
        }}
      />
      <path
        d="M1689.37 738.65c4.29-.24 4.86 1.98 5.17 7.63.3 5.64 7.98 211.56 8.36 214.94.38 3.38.57 7.82-3.95 7.95-4.52.13-4.87-5.05-4.82-8.3s-8.38-210.95-8.47-213.77-1.36-8.16 3.72-8.45Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        d="m1680.68 752.85-.48 15.23s3.69 12.01 4.39 17.09c.56 4.1 1.15 11.08 1.15 11.08s5.27-.55 6-3.46c.73-2.92 2.54-10.54 2.54-10.54l2.54 17.23s7.58-3.37 8.31-5.31c.73-1.94-.16-7.06 1.05-7.55 1.21-.49 7.53-5.35 8.75-8.02 1.21-2.67-4.37-17.98-8.02-23.81-3.64-5.83-4.13-16.52-4.13-16.52l-22.11 2.92v11.66ZM1408.91 743.23l2.53 15.03s-2.04 12.4-2.04 17.52c0 4.14.35 11.14.35 11.14s-5.3.17-6.42-2.62-3.94-10.1-3.94-10.1l-.2 17.42s-7.97-2.31-8.95-4.14c-.98-1.83-.79-7.02-2.06-7.34-1.27-.32-8.18-4.28-9.75-6.77-1.56-2.48 1.91-18.41 4.73-24.68 2.83-6.27 1.87-16.93 1.87-16.93l22.3-.09 1.57 11.56Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1667.14 639.96c-15.57 9.52-18.28 20.48-14.76 34.75 3.52 14.27 26.31 74.87 26.31 74.87l25.09-4.21 2.82-11.3s12.56-5.76 9.85-29.56c-2.68-23.56-37.35-71.86-49.32-64.55Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1450.93 784.93s44.74 31.72 93.47 30.01c48.73-1.71 89.81-30.01 89.81-30.01l-21.41-196.57-144.48 4.51s-13.96 191.2-17.38 192.06Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1510.93 569.37s-57.72 11.83-74.62 31.18c-19.79 22.67-46.32 27.45-59.04 55.8-11.76 26.2 37.6 31.82 37.6 31.82s27.07-11.99 31.82-14.46c14.46-7.52 37.47-9.4 45.96-31.68 8.48-22.28 31.89-65.54 18.29-72.66ZM1597.43 581.96s19.93-12.25 37.56 6.45c15.97 16.94 59.97 71.44 66.03 80.26 5.98 8.71-39.06 30.69-39.06 30.69s-23.75-23.65-27.75-27.21c-11.12-9.89-33.79-11.34-42.27-33.63-8.48-22.28-8.1-49.45 5.5-56.57Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1513.24 564.24s-17.52 7.99-30.48 13.06c-17.17 6.72-20.53 10.94-20.53 10.94s-6.48 76.33-8.36 110.98c-1.43 26.47 36.38 50.36 36.38 50.36l124.73-4.05c.34 0 27.33-11.85 18.53-59.33-12.53-67.62.67-93.58-3.47-101.37-7.49-14.09-116.8-20.61-116.8-20.61Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1440.81 792.35 222.18 113.56-3.51-15.47L1437.66 776l3.15 16.35z"
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1440.33 888.52 215.56-108.43 1.12 13.16-210.94 106.28-5.74-11.01z"
      />
      <path
        style={{
          fill: 'none',
        }}
        d="m1658.84 783.62 16.48 1.32 3.29 142.41-17.8 1.98-1.97-145.71zM1442.69 790.79l-15.15-8-3.3 142.41 17.81 1.98.64-136.39z"
      />
      <path
        d="M1442.22 784.76c-6.6 0-5.17 14.11-5.64 21.16-.47 7.05 1.32 153.77 1.32 153.77l13.28.63s-2.84-143.58-2.37-152.52c.47-8.94 1.41-23.04-6.58-23.04Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1673.14 725.01c5.72-.16 7.22 4.12 7.7 12.53.48 8.37 8.23 225.83 8.42 232.41.19 6.58-.47 13.78-7.92 14-7.46.21-8.11-7.34-8.09-13.94.03-7.33-7.22-223.87-7.55-230.9-.34-7.45-.92-13.86 7.45-14.09Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1663.94 947.27c13.53.17 13.67 21.75 14 33.31.33 11.56 3.32 29.93-11.69 29.86-11.41-.05-13.59-10.44-14.31-26.9-.72-16.47-5.97-36.49 12-36.27Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1654.24 786.34c6.59-.35 5.91 13.82 6.75 20.84.84 7.02 4.59 153.78 4.59 153.78l-12.65 2.53s-3.11-144.89-4.05-153.79c-.94-8.9-2.62-22.94 5.37-23.36Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="m1670.86 949.21.71 21.62-100.15 4.36.27-16.72 83.16-4.07s.45-6.09 4.12-8.08c9.16-4.96 11.88 2.9 11.88 2.9Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1543.5 727.69c-27.67.86-53.98-18.45-65.51-20.3-11.53-1.85-27.68.46-35.99 7.38-8.3 6.92-3.23 61.82 6.46 93.66 9.69 31.83 18.45 60.44 17.53 73.36-.92 12.92 8.76 41.65 8.76 41.65s7.39-5.2 22.62.34c15.22 5.54 19.14 2.58 17.76 2.58s8.32-10.87 9.24-22.86c.92-12 5.29-20.78-1.63-38.31s-20.76-77.97-20.76-77.97 26.3 5.07 42.44 3.23c16.15-1.85 49.37-9.23 49.37-9.23s-7.84 73.36-2.77 86.27c5.07 12.92 6.46 21.22 2.31 26.76-4.15 5.54 2.55 35.03 2.55 35.03s9.9-7.35 26.05-6.42c16.15.92 12.38-8.66 12.38-8.66s9.49 5.55 14.11-17.51c4.61-23.07-2.96-73.02-.65-99.78 2.31-26.76 11.07-45.21 3.23-70.59-7.84-25.37-26.76-25.37-40.14-21.22-13.38 4.15-52.59 22.15-67.36 22.61Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1600.77 873.48s-.25 16.88-1.74 23.09c-1.49 6.21-1.74 21.6-1.74 21.6l37 10.18s.25-12.42-.74-20.11c-.99-7.7-1.74-16.64-1.24-21.6.5-4.97 2.98-15.89 2.98-15.89l-34.51 2.73Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1614.18 900.8c-12.45.82-14.15 11.42-17.88 14.65-3.72 3.23-4.47 8.69-4.47 8.69s4.72 10.43 4.72 18.37 6.7 23.34 6.7 23.34 15.39-1.24 27.81-1.74c12.42-.5 22.6-2.48 22.6-2.48s4.22-4.97-.74-14.15c-4.97-9.19-8.19-8.19-13.16-18.37-4.97-10.18-6.7-16.64-6.7-16.64s-3.72-12.66-18.87-11.67Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-b)',
        }}
      >
        <path
          d="M1589.35 937.3c.25.74 5.21 12.17 13.66 14.65 8.44 2.48 27.06-1.24 36-1.24 8.94 0 15.15-3.48 15.15-3.48l5.21 26.82-76.23-3.48 6.21-33.27Z"
          style={{
            fill: '#dda141',
          }}
        />
      </g>
      <path
        d="M1538.59 520.54c-13.46-.79-34.44.4-41.17 14.25-6.73 13.86-6.33 22.56-6.33 22.56s-15.04 4.35-17.42 16.63c-2.38 12.27.4 11.88 3.56 27.71 3.17 15.83 14.69 41.11 24.59 58.13 9.9 17.02 11.92 39.44 11.92 39.44s49.9-4.17 72.46-44.95c22.56-40.77 10.97-47.48 15.72-61.74 4.75-14.25 1.19-30.09-4.75-36.02-5.94-5.94-9.5-5.94-9.5-5.94s-1.98-15.83-12.27-17.42c-10.29-1.58-36.81-12.67-36.81-12.67Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-c)',
        }}
      >
        <path
          d="M1485.94 539.15s23.36 65.71 36.02 73.63c12.67 7.92 31.27 0 49.09-19.79 17.81-19.79 21.38-56.61 21.38-56.61l-95.01-49.88-11.48 52.65Z"
          style={{
            fill: '#f08d64',
          }}
        />
      </g>
      <path
        d="M1555.31 461.32c-3.44-1.32-21.13-16.46-41.79-4.81-20.66 11.65-24.43 52.75-24.43 52.75l8.84-9.45s-4.32 8.63-5.54 14.55c-2.08 10.05 1.04 21.82 1.04 21.82l5.2-13.51s-1.28 15.72 6.23 23.55c5.86 6.11 13.82 8.86 20.44 13.16l21.43 1.71s23.08-7.15 29.93-19.07c6.14-10.7 8.06-27.73 8.06-27.73l3.77 10.49s2.35-22.89-1.43-35.09c-5.17-16.65-13.36-28.74-19.84-29.15-6.98-.44-11.9.77-11.9.77Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1553.77 478.83s-8.37 20.77-15.44 28.08c-7.06 7.32-19.07 13.55-19.07 13.55l12.06-20.44s-10.24 2.33-15.78 9.55c-6.22 8.11-6.92 20.47-1.62 29.55 5.3 9.08 10.6 19.68 22.2 19.43s15.63-4.43 22.95-9.73c7.32-5.3 8.84-7.42 10.35-14.49 1.51-7.06 1.04-14.67 1.04-14.67l-12.55 14.57s3.48-18.74.81-29.96c-1.24-5.21-4.94-25.45-4.94-25.45Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-d)',
        }}
      >
        <path
          d="M1546.39 498.6s2.55-2.24 7.49-3.62c3.08-.86 11.38 2.42 11.38 2.42l-.36 1.45s-5.01-2.24-9.49-.91-7.33 4.06-7.33 4.06l-1.69-3.39Z"
          style={{
            fill: '#6b5738',
          }}
        />
      </g>
      <path
        d="M1515.93 532.82s3.97 18.28 4.47 23.07 4.04 17.23 17.41 17.48 17.53-11.31 21.32-15.85c3.78-4.54 6.75-18.14 6.75-18.14l-49.95-6.56Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1529.27 541.63c1.17.9 5.21.19 9.44-.05 4.23-.24 7.93-1.17 8.29-2.75.36-1.57-1.27-6.57-4.54-6.69s-5.08 1.33-5.08 1.33-2.85.37-6.6 1.58c-3.75 1.21-3.09 5.37-1.51 6.58Z"
        style={{
          fill: '#eb6a36',
        }}
      />
      <path
        d="M1551.83 506.4c1.71.59 2.52 2.16 1.88 3.82-.64 1.66-1.97 1.96-3.54 1.53-1.85-.51-2.51-1.97-2.02-3.73.34-1.25 1.92-2.22 3.68-1.61Z"
        style={{
          fill: '#235a96',
        }}
      />
      <path
        style={{
          fill: '#235a96',
        }}
        d="m1557.91 505.09-9.76 3.56-.78-3.39 8.8-4.47 1.74 4.3z"
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1664.67 704.28 3.03 85.57-13.45.87-1.88-85.16 12.3-1.28z"
      />
      <path
        d="m1667.89 696.4.73 10.71-20.37 1.39s-.55-8.1-.49-10.99c.06-2.89 4.57-6.09 10.07-6.2 5.5-.11 9.79 1.17 10.06 5.09ZM1686.55 805.78c-2.09-4.85-9.1-4.41-13.14-1.13-4.04 3.28-19.13 17.32-19.13 17.32l.94 3.14 13.1-6.8s7.3-.77 12.93-2.02c4.5-1 7.39-5.66 5.3-10.51Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1379.58 652.31c19.29-22.8 56.99 5.49 56.99 5.49s-15.93 55.6-17.24 60.92c-3.52 14.27-8.94 25.62-8.94 25.62l-28.31-2.14-2.14-10.68s-12.73-7.96-9.45-30.56c3.41-23.47 3.2-41.7 9.08-48.65Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1423.09 701.25 2.66 87.47 13.98 2.93-3.93-91.42-12.71 1.02z"
      />
      <path
        d="M1420.02 691.85v10.73h20.42s0-8.12-.26-11c-.26-2.88-4.97-5.76-10.47-5.5-5.5.26-9.69 1.83-9.69 5.76Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1420.11 724.6c-5.69.63-8.05 4.62-8.15 12.61-.11 8.38-.78 225.34-.78 231.92 0 6.58.86 13.76 8.32 13.76s7.9-7.57 7.68-14.16c-.24-7.32 1.36-224.04.92-231.06-.44-7.02-.1-13.95-8-13.07Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1435.73 942.01c-13.52.56-13.04 22.14-13.04 33.7 0 11.56-2.46 30.01 12.54 29.52 11.4-.37 13.28-10.82 13.53-27.3s4.92-36.65-13.04-35.91Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1432.94 952.47v21.64l99.72.15-.82-16.71-82.74-.42s-.65-6.08-4.38-7.94c-9.31-4.66-11.78 3.29-11.78 3.29Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1505.47 870.5s2.28 16.73 4.51 22.71 4.33 21.24 4.33 21.24l-35.5 14.56s-1.74-12.29-1.68-20.06c.06-7.76-.28-16.72-1.37-21.59-1.09-4.87-4.87-15.42-4.87-15.42l34.59-1.45Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1495.45 899.23c12.46-.69 15.43 9.63 19.51 12.39 4.09 2.76 5.48 8.09 5.48 8.09s-3.43 10.92-2.47 18.81c.96 7.89-3.84 23.98-3.84 23.98s-15.43.62-27.82 1.62c-12.38 1-22.73.26-22.73.26s-4.79-4.42-.96-14.14c3.82-9.72 7.15-9.12 10.85-19.83 3.7-10.7 4.65-17.32 4.65-17.32s2.17-13.02 17.33-13.86Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#classmate1-e)',
        }}
      >
        <path
          d="M1524.49 932.47c-.16.77-3.71 12.71-11.79 16.19-8.08 3.48-27.02 2.03-35.89 3.1-8.87 1.08-15.45-1.63-15.45-1.63l-1.95 27.25 75.25-12.63-10.17-32.28Z"
          style={{
            fill: '#dda141',
          }}
        />
      </g>
      <path
        d="m1442.39 818.84-12.3-8.54s-4.31-3.77-9.1-5.82c-4.79-2.05-11.65-.56-12.33 4.68-.68 5.24 3.38 8.93 7.98 8.66 5.76-.34 12.99-1.6 12.99-1.6l11.83 5.84.92-3.23Z"
        style={{
          fill: '#1a4431',
        }}
      />
    </svg>
  )
}

export default Classmate1Start
